import { PopoverOrigin } from '@mui/material';

export const totalAnchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const totalTransformOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const discountAnchorOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};
export const discountTransformOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};
